/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Important_Pricing_PendingInputs */

const en_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pricing will be calculated based on file size.`)
};

const fr_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le tarif sera calcule en fonction de la taille du fichier.`)
};

const de_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Preis wird anhand der Dateigröße berechnet.`)
};

const it_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il prezzo verrà calcolato in base alle dimensioni del file.`)
};

const ru_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стоимость будет рассчитываться исходя из размера файла.`)
};

const es_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El precio se calculará en función del tamaño del archivo.`)
};

const zh_cn2_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`价格将根据文件大小计算。`)
};

const ja_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`価格はファイルサイズに基づいて計算されます。`)
};

const hi_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मूल्य निर्धारण फाइल के आकार के आधार पर किया जाएगा।`)
};

const pt_pt2_embed_captions_important_pricing_pending = /** @type {(inputs: Embed_Captions_Important_Pricing_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O preço será calculado com base no tamanho do arquivo.`)
};

/**
* | output |
* | --- |
* | "Pricing will be calculated based on file size." |
*
* @param {Embed_Captions_Important_Pricing_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_important_pricing_pending = /** @type {((inputs?: Embed_Captions_Important_Pricing_PendingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Important_Pricing_PendingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_important_pricing_pending(inputs)
	if (locale === "de") return de_embed_captions_important_pricing_pending(inputs)
	if (locale === "it") return it_embed_captions_important_pricing_pending(inputs)
	if (locale === "ru") return ru_embed_captions_important_pricing_pending(inputs)
	if (locale === "es") return es_embed_captions_important_pricing_pending(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_important_pricing_pending(inputs)
	if (locale === "ja") return ja_embed_captions_important_pricing_pending(inputs)
	if (locale === "hi") return hi_embed_captions_important_pricing_pending(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_important_pricing_pending(inputs)
	return en_embed_captions_important_pricing_pending(inputs)
});